export const BUS_EVENTS = {
    SHOW_BACKDROP: '_backdrop.show',
    HIDE_BACKDROP: '_backdrop.hide'
};
